import React from "react";
import { Box, Chip } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import M3Tooltip from "../common/M3Tooltip";

interface LabelProps {
  color?: string;
  name?: string;
  labelCompleteMode: boolean;
}

export const Label: React.FC<LabelProps> = ({
  color,
  labelCompleteMode,
  name,
}) => {
  const theme = useTheme();
  const labelColor = color || theme.palette.primary.main;
  const isDark = theme.palette.mode === "dark";
  const labelTextColor = isDark
    ? theme.palette.getContrastText(labelColor)
    : labelColor;
  const labelBackgroundColor = isDark ? labelColor : "transparent";
  const labelBorderColor = isDark ? alpha(labelTextColor, 0.35) : labelColor;

  if(!labelCompleteMode) {
    return <M3Tooltip title={name}>
      <Box sx={{ height: 5, borderRadius: 1, backgroundColor: labelColor, width: 25 }}></Box>
    </M3Tooltip>
  }
  return (
    <Chip
      sx={{
        "& .MuiChip-label": {
          px: 1,
          py: 1,
        },
        fontSize: 13,
        height: 21,
        fontWeight: 500,
        borderRadius: 1,
        backgroundColor: labelBackgroundColor,
        borderColor: labelBorderColor,
        borderWidth: 2,
        borderStyle: "solid",
        color: labelTextColor,
        marginRight: "0.8em",
      }}
      label={name}
    />
  );
};
